import { uniqBy } from 'lodash';
import { CapIQCompanyData } from 'pages/ValuationsAllocation/types';
import { getStringValue } from 'utilities';

const uniqueCompaniesData = (companiesData: CapIQCompanyData[] | null) => {
  if (!companiesData) {
    return [];
  }

  return uniqBy(companiesData, comp => getStringValue(comp?.requested_identifier)?.toUpperCase());
};

export default uniqueCompaniesData;